import clsx from "clsx";
import { useMemo } from "react";

import { ActionButton } from "../../../fkc/components/shared/submit-button/submit-button.component";
import { getTotalSweepEntries } from "../../../shared/utils";
import { SNHU_EXTRA_ENTRIES } from "../../constants/snhu.constants";


interface ConfirmationPageProps {
  skipSnhu: VoidFunction;
}


export function ConfirmationPage({ skipSnhu }: ConfirmationPageProps): JSX.Element {
  const totalEntries = useMemo((): number => {
    const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
    return getTotalSweepEntries(submission?.data);
  }, []);

  return (
    <div className="snhu__children__container">
      <div className="snhu__children">
        <p className="snhu__children--title">
          You have earned <strong>{SNHU_EXTRA_ENTRIES}</strong> additional entries! <br />
          Your entries: <strong>{totalEntries}</strong>
        </p>
      </div>

      <div className={clsx("lander__cpl__quiz__body", "snhu__content--buttons-body")}>
        <div className={clsx("lander__cpl__quiz__body--question-container", "no-margin")}>
          <div className="lander__cpl__quiz__body--question-actions">
            <div className={clsx("lander__cpl__quiz__body--button-container", "no-padding-top")}>
              <ActionButton className="full-width" onClick={skipSnhu}>
                Continue
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
